var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-breadcrumbs',{staticClass:"breadcrumbs-container",attrs:{"id":"article-breadcrumbs","items":_vm.items,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{staticClass:"breadcrumb-item display-16",attrs:{"exact":"","href":item.Link}},[_vm._v(_vm._s(item.KeyValue.Value))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }